const filteredPoiList = (state) => {
  let poiList = state.poiList;

  const filteredTypes = state.filters.typeList
    .filter(type => type.active).map(type => type.slug);
  if (filteredTypes.length > 0) {
    poiList = poiList.filter(poi => filteredTypes.includes(poi.type));
  }
  return poiList;
};

export default {
  filteredPoiList
};



// WEBPACK FOOTER //
// ./src/store/modules/neighbourhood/getters.js